<script lang="ts" setup>
  import { ref, inject, type ComputedRef } from 'vue'
  import RamadanModal from '@/shared/components/RamadanModal/RamadanModal.vue'
  import { useGoogleAnalytics } from '@/shared/composables'

  const isRtl = inject('isRTL') as ComputedRef<boolean>
  const expandedHeader = ref(true)
  const modalIsOpen = ref(false)
  const gaService = useGoogleAnalytics()
  const showModal = (title: string) => {
    modalIsOpen.value = true
    gaService.sendOutboundSelectPlanPromo(title)
  }

  const closeBanner = () => {
    expandedHeader.value = false
    localStorage.setItem('qic-qatar-travel.ramadan.bannerIsClosed', 'true')
  }

  const bannerIsClosed = ref(
    localStorage.getItem('qic-qatar-travel.ramadan.bannerIsClosed') === 'true'
  )
  expandedHeader.value = !bannerIsClosed.value
</script>

<template>
  <RamadanModal v-model="modalIsOpen" :class="{ rtl: isRtl }" data-test="ramadan-modal" />
  <transition name="slide-fade" :class="{ rtl: isRtl }">
    <div v-if="expandedHeader" class="ramadan-header" @click="showModal('ramadan_header')">
      <div class="ramadan-header__content">
        <div class="ramadan-header__background">
          <img
            src="@/shared/assets/images/ramadan/background-pattern.png"
            alt="background"
            class="ramadan-header__background-image"
          />
          <img
            src="@/shared/assets/images/ramadan/background-pattern.png"
            alt="background"
            class="ramadan-header__background-image ramadan-header__background-image_reversed"
          />
        </div>
        <img
          class="ramadan-header__logo"
          src="@/shared/assets/images/ramadan/app-logo.svg"
          alt="qic app logo"
        />
        <div class="ramadan-header__title">
          <span class="ramadan-header__text-1">{{ $t('ramadan.header.text.1') }}</span>
          <div class="ramadan-header__images">
            <img
              src="@/shared/assets/images/ramadan/car.png"
              alt="car"
              class="ramadan-header__car"
            />
            <img
              src="@/shared/assets/images/ramadan/light.png"
              alt="light"
              class="ramadan-header__light"
            />
          </div>
          <span class="ramadan-header__text-2">{{ $t('ramadan.header.text.2') }}</span>
        </div>
        <button
          class="ramadan-header__button"
          aria-label="close button"
          @click.stop="closeBanner"
          data-test="ramadan-banner-close-button"
        >
          <img src="@/shared/assets/images/ramadan/x-close.svg" alt="close" />
        </button>
      </div>
    </div>
  </transition>
  <transition name="slide">
    <div
      v-if="!expandedHeader"
      :class="['ramadan-gifts', { rtl: isRtl }]"
      @click="showModal('ramadan_tickets')"
    >
      <img
        src="@/shared/assets/images/ramadan/gifts.png"
        alt="gifts"
        class="ramadan-gifts__image"
      />
    </div>
  </transition>
</template>

<style lang="scss" scoped>
  @import './RamadanBanner';
</style>
